
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import { CardViewModel } from '@/entities/CardViewModel';
import ControlType from '@/enums/ControlType';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import { StoreHelper } from '@/store/StoreHelper';
import { Root, Store } from '@/main';

@Component
class Card extends Vue {
  @Prop() private eventVisibilityCard?: CardViewModel;

  private localCard = new CardViewModel();
  private readMoreIcon = require('@/assets/Images/read-more-icon.svg');
  private copyIcon = require('@/assets/Images/copy-icon.svg');
  private isReadMoreVisible = false;
  private isHideTitle = false;
  private isReadMoreEnabled = false;
  private contactUsToEnableLink = 'https://support.ventla.io/in-admin-tutorials/g5lc4iik0pUZjRg2sQFv/contact-us-to-enable';
  private hollowGreenTickIcon = require('@/assets/Images/hollow-green-tick.svg');
  private exclamationIcon = require('@/assets/Images/exclamation-icon.svg');
  private informationIcon = require('@/assets/Images/info-icon.svg');
  private qrCodeIcon: string = require('@/assets/Images/QR_code_icon.svg');
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private reqInfo: AppRequestInfo = this.storeHelper.GetRequestInfoFromStore();
  private isCallbackReturned = false;
  private showQRCode = false;
  private isHideInformationString = false;
  private showInformationTooltip  = false;
  private cardVisibilityElementId = '';
  private isMounted = false;
  private tooltipStyle = '';

  private mounted() {
    // returns a boolean value if the user is using a mobile or ipad browser or not
    this.isReadMoreEnabled = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.localCard = this.eventVisibilityCard!;
    if (this.localCard !== null && this.localCard !== undefined && (this.localCard.Title === '' || this.localCard.Title === null)) {
      this.isHideTitle = true;
    }
    this.isCallbackReturned = this.reqInfo.IsZapierAvailableInApplicationZapierCallback;
    if (this.localCard !== null && this.localCard !== undefined && (this.localCard.InformationString === '' || this.localCard.InformationString === undefined)) {
      this.isHideInformationString = true;
    }
    this.cardVisibilityElementId = '#divEventVisibility'+ this.localCard.Id;
    this.isMounted = true;
  }
  private  TeleportTargetExists() {
    return document.querySelector(this.cardVisibilityElementId) !== null;
  }
  private selectItem(val: CardViewModel) {
    if (this.localCard.ControlType === ControlType.GreenTick || this.localCard.ControlType === ControlType.CheckBox || this.localCard.ControlType === ControlType.CheckBoxAndLabel) {
      this.localCard.IsSelected = !this.localCard.IsSelected;
      this.$emit('selected-card-value', val);
    }
  }
  private getReadMore(val: boolean) {
    if (!this.isReadMoreEnabled) {
      this.isReadMoreVisible = val;
    }
  }
  private IsDesciptionHidden() {
    return this.localCard.ControlType === ControlType.CheckBoxAndLabel && this.localCard.IsSelected && this.IsInputBoxVisible();
  }
  private IsInputBoxVisible() {
    return (this.localCard.InputBoxData !== null && this.localCard.InputBoxData !== undefined && this.localCard.InputBoxData !== '');
  }
  private CopyKeyToClipboard(val: string) {
    this.$emit('show-copied-key',val);
  }
  private GetIconImage() {
    return this.IsInputBoxVisible() && this.isCallbackReturned ? this.hollowGreenTickIcon : (this.IsInputBoxVisible() ? this.informationIcon : this.exclamationIcon);
  }
  // Used to show / hide Qr code popup
  private ShowQRCode() {
    this.showQRCode = !this.localCard.QRCodeData!.ShowQRCode;
    if(this.localCard.QRCodeData !== null && this.localCard.QRCodeData !== undefined) {
      this.localCard.QRCodeData.ShowQRCode = this.showQRCode && this.localCard.QRCodeData.QRCodeURL !== null && this.localCard.QRCodeData.QRCodeURL !== undefined && this.localCard.QRCodeData.QRCodeURL !== '';
      Root.emit('show-qr-code', {FeatureCardIndex: this.localCard.Id, QRCodeData:this.localCard.QRCodeData});
    }
  }

  // Calculates the left offset of the tooltip relative to its container
  private CalculateOffsetLeft() {
    const icon = this.$refs.infoIcon as HTMLElement;
    const container = this.$refs.cardContainer as HTMLElement;

    if (icon && container) {
      const iconRect = icon.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      if (window.innerWidth > 1300) {
        const offsetLeft = (iconRect.left - containerRect.left) + 10;
        this.tooltipStyle =   offsetLeft + 'px' ;
      }
    }
  }

  // Controls tooltip visibility and triggers position calculation if being shown
  private GetInformationString(val: boolean) {
    this.showInformationTooltip = val;
    if (val) {
      this.CalculateOffsetLeft();
    }
  }

  // Determines whether the tooltip should be displayed, based on content and visibility flag
  private ShowInformationTooltip(){
    return (
      this.showInformationTooltip &&
      this.localCard.InformationString !== '' &&
      this.localCard.InformationString !== null &&
      this.localCard.InformationString !== undefined
    );
  }
}
export default toNative(Card);
